<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" style="width: 250px; border-radius: 16px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >App setting</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list dark class="py-0">
        <v-list-tile v-for="item in items" :key="item.title" :to="item.url">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="white--text">{{
            item.title
          }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-tooltip right>
        <v-list dark class="py-0 my-list" slot="activator">
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>power_settings_new</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="white--text"
              >Free & Easy</v-list-tile-content
            >
            <v-list-tile-action style="padding-left: 10px">
              <v-switch
                :disabled="isLoadingFree"
                color="primary"
                @change="changeFreeStatus()"
                v-model="free_delivery_status.status"
              ></v-switch>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <span>Switch to close/open Free & Easy</span>
      </v-tooltip>
      <v-list class="py-0" style="overflow: hidden">
        <v-list-group
          v-for="item in items_group"
          v-model="item.active"
          :key="item.title"
          :prepend-icon="item.action"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="item.alert_all">
              <v-btn
                fab
                color="primary"
                style="height: 25px; width: 25px"
                class="black--text"
                >{{
                  item.alert_all == 1
                    ? count_rider.user
                    : count_rider.request_money
                }}</v-btn
              >
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile
            v-for="subItem in item.items"
            :key="subItem.title"
            :to="subItem.url"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="subItem.alert">
              <v-btn
                fab
                color="primary"
                style="height: 25px; width: 25px"
                class="black--text"
                >{{
                  item.alert_all == 1
                    ? count_rider.user
                    : count_rider.request_money
                }}</v-btn
              >
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isLoadingFree: false,
      items: [
        {
          icon: "crop_7_5",
          title: "Set banner",
          url:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/setapp/setpromotionbanner",
        },
        {
          icon: "crop_portrait",
          title: "Set popup",
          url:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/setapp/setapp_popup",
        },
        {
          icon: "storefront",
          title: "Set store",
          url:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/setapp/setapp_store",
        },
        // {
        //   title: "Set store type",
        //   url:
        //      "/weserve_admin_login/control/" +
        //     this.$store.state.backOffice.province +
        //     "/setapp/setapp_storetype"
        // }
        {
          icon: "border_all",
          title: "Set sub district",
          url:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/setapp/setapp_subdistrict",
        },
        {
          icon: "do_not_disturb",
          title: "Out-of-service Area",
          url:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/setapp/setoutofservicearea",
        },
        {
          icon: "credit_card",
          title: "Payment Setting",
          url:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/setapp/paymentmethod",
        },
      ],

      items_group: [],
    };
  },
  methods: {
    async changeFreeStatus() {
      this.isLoadingFree = true;
      let form = {
        province_free_delivery: this.free_delivery_status.status,
      };
      let check_res = await this.$store.dispatch(
        "fetchFoodSetAppBack/editFreeDeliveryStatus",
        { province_id: this.findProvince(this.$route.params.province), form }
      );
      if (check_res == false) {
        this.free_delivery_status.status = !this.free_delivery_status.status;
      }
      this.isLoadingFree = false;
    },
    splitProvince(province) {
      let province_set = "";
      let province_split = province.split(" ");
      for (let val of province_split) {
        province_set += val;
      }
      return province_set;
    },
    findProvince(province) {
      let result = null;
      for (let val of this.provinceData) {
        if (
          this.splitProvince(val.province_name_en.toLowerCase()) == province
        ) {
          result = val.province_id;
        }
      }
      return result;
    },
  },
  destroyed() {},
  computed: {
    ...mapState({
      count_rider: (state) => state.fetchRiderListBack.count_rider,
      free_delivery_status: (state) =>
        state.fetchFoodSetAppBack.free_delivery_status,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
  },
  async created() {
    this.isLoadingFree = true;
    await this.$store.dispatch(
      "fetchFoodSetAppBack/getFreeDeliveryStatus",
      this.findProvince(this.$route.params.province)
    );
    this.isLoadingFree = false;
  },
};
</script>

<style scoped>
.my-list {
  background-color: #424242;
}
.my-list:hover {
  background-color: #515151;
  cursor: default;
}
</style>


